import React from "react";
import { Box, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import IconCardSelect from "./IconCardSelect";
import {
  ArchitectureIcon,
  EngineeringIcon,
  ConstructionIcon,
  AdministrationIcon,
  IndustryIcon,
  LookingIcon,
  ListeningIcon,
  EmployedIcon,
} from "./onboardingIcons";
import {
  availabilities,
  companyIndustryMap,
} from "bundles/common/utils/constants";

const sectorIcons = {
  architecture: ArchitectureIcon,
  engineering: EngineeringIcon,
  construction: ConstructionIcon,
  administration: AdministrationIcon,
  industry: IndustryIcon,
};

const availabilityIcons = {
  looking: LookingIcon,
  listening: ListeningIcon,
  currently_employed: EmployedIcon,
};

const labelSx = {
  fontFamily: "'Segoe UI Semibold', system-ui, sans-serif",
  fontSize: "1rem",
  color: "hsl(222.2, 84%, 4.9%)",
  mb: "0.75rem",
  "& sup": {
    color: "hsl(0, 84.2%, 60.2%)",
    marginLeft: "0.15rem",
    fontSize: "0.75em",
    lineHeight: 0,
  },
};

const StepJobSearch = ({ values, errors, handleCardSelected }) => {
  const intl = useIntl();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
      <Box id="ob-field-desired_sector">
        <Typography sx={labelSx}>
          <FormattedMessage id="onboarding.looking_for" />
          <sup>*</sup>
        </Typography>
        <IconCardSelect
          multiple
          fieldName="desired_sector"
          selected={values.desired_sector}
          values={companyIndustryMap.map((industry) => ({
            code: industry,
            icon: sectorIcons[industry],
            label: intl.formatMessage({
              id: `company.company_industry.${industry}`,
            }),
          }))}
          onChange={handleCardSelected}
        />
        {errors.desired_sector && (
          <Typography sx={{ color: "hsl(0, 84.2%, 60.2%)", fontSize: "0.75rem", mt: "0.25rem" }}>
            {errors.desired_sector}
          </Typography>
        )}
      </Box>

      <Box id="ob-field-availability">
        <Typography sx={labelSx}>
          <FormattedMessage id="onboarding.looking_how" />
          <sup>*</sup>
        </Typography>
        <IconCardSelect
          fieldName="availability"
          selected={values.availability}
          values={availabilities.map((availability) => ({
            code: availability,
            icon: availabilityIcons[availability],
            label: intl.formatMessage({
              id: `candidate.${availability}`,
            }),
          }))}
          onChange={handleCardSelected}
        />
        {errors.availability && (
          <Typography sx={{ color: "hsl(0, 84.2%, 60.2%)", fontSize: "0.75rem", mt: "0.25rem" }}>
            {errors.availability}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default StepJobSearch;
